import { type PropsWithChildren } from "react";
import { type ColumnMeta } from "@tanstack/react-table";

import { ContextMenu, type ContextMenuProps } from "src/components/ContextMenu/ContextMenu";
import { ContextMenuIcon } from "src/components/Icon/Navigation";

import styles from "./ContextMenuCell.module.css";

const ContextMenuCell = ({ children, ...props }: PropsWithChildren<ContextMenuProps>) => (
  <div className={styles.menuContainer}>
    <ContextMenu toggleIcon={ContextMenuIcon} {...props}>
      {children}
    </ContextMenu>
  </div>
);

export const contextMenuCellMeta: ColumnMeta<unknown, unknown> | undefined = {
  align: "start",
};

export const contextMenuColDef = {
  meta: contextMenuCellMeta,
  enableSorting: false,
  id: "context-menu",
  header: () => <span />,
  cell: ContextMenuCell,
};

export default ContextMenuCell;
